module.exports = __webpack_public_path__ + "media/images/me-icon-8666bc02020b99248182ec9fa2a30a43.svg";